<mat-dialog-content>
  <lemon-dialog-header> Muokkaa viitenumeroa </lemon-dialog-header>

  <div class="tosite-tiedot">
    <form novalidate style="margin: 0">
      <mat-form-field>
        <input type="text" matInput tahtiOhjeeseen [formField]="lomake.viitenumero" placeholder="Viitenumero" data-lpignore="true" />
        @if (onkoVirhe(lomake.viitenumero, 'viitenumero') && (lomake.viitenumero().dirty() || lomake.viitenumero().touched())) {
          <mat-error> Viitenumero ei ole validi </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0; justify-content: space-around; justify-content: space-evenly">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (muokkaa viitenumeroa dialog)">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Muokattu kirjauksen viitenumeroa" [actionContext]="[lomake().value()]">Tallenna</app-primary-button>
</mat-dialog-actions>
